import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdOutlinePassword } from "react-icons/md";
import { useSelector } from "react-redux";

function SettingsTab() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const handlePasswordClick = (event, index) => {
    setSelectedIndex(index);
    navigate("/change-password");
  };
  const roles = useSelector((state) => state.auth.user.roles);
  return (
    <List
      component="nav"
      sx={{
        p: 0,
        "& .MuiListItemIcon-root": {
          minWidth: 32,
          color: theme.palette.grey[500],
        },
      }}
    >
      {!roles.any(["vending_machine"]) && (
        <ListItemButton
          selected={selectedIndex === 0}
          onClick={(event) => handlePasswordClick(event, 0)}
        >
          <ListItemIcon>
            <MdOutlinePassword />
          </ListItemIcon>
          <ListItemText primary="Change password" />
        </ListItemButton>
      )}
    </List>
  );
}

export default SettingsTab;